export const documentList = {
  container:
    "w-full box-border md:max-w-md lg:max-w-lg my-30 xl:max-w-xl mx-auto  px-[35px] md:px-[15px] ",
  infoContainer: "max-w-[1100px] mx-[15px]",
  brandName: "brandname bg-[#DEEBF7] px-[8px] p-[5px] mb-10 font-bold",
  infoDate: "info-data flex justify-between bg-[#FBE5D6] px-[8px] py-5 mb-10",
  subdata: "ml-50 pre-wrap bg-[#FFF2CC] px-[8px] py-5 mr-150 mb-10",
  heading:
    "flex justify-around mb-[-20px] bg-[#807E7E] mx-[15px] text-white font-bold",
  subHeading: "ml-[150px]",
}
